// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3RImv","tab":"Tabs_tab__2JXaF","tabActive":"Tabs_tabActive__2P1h_"};